import type { LessonClassTeacher } from '@mathflat/domain/LessonClass'

import ExtendedMap from '@/models/ExtendedMap'

import { DTO } from '../DTO'

type Key = LessonClassTeacher['teacherId']

export class ClassAssignedTeacherColl extends DTO {
  private teachersMap: ExtendedMap<Key, LessonClassTeacher>

  constructor(props: LessonClassTeacher[]) {
    super()
    this.teachersMap = ExtendedMap.fromArr(props, 'teacherId')
  }

  get toArr() {
    return [...this.teachersMap.values()]
  }

  get toKeyArr() {
    return [...this.teachersMap.keys()]
  }

  get(id: Key) {
    return this.teachersMap.get(id)
  }
}
